'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CMS_COMPONENT_BREADCRUMBS_FETCH = exports.CMS_COMPONENT_BREADCRUMBS_FETCH = 'CMS_COMPONENT_BREADCRUMBS_FETCH';
var CMS_COMPONENT_BREADCRUMBS_FETCH_FULFILLED = exports.CMS_COMPONENT_BREADCRUMBS_FETCH_FULFILLED = 'CMS_COMPONENT_BREADCRUMBS_FETCH_FULFILLED';

var CMS_COMPONENT_POPUP_TOGGLE = exports.CMS_COMPONENT_POPUP_TOGGLE = 'CMS_COMPONENT_POPUP_TOGGLE';
var CMS_COMPONENT_POPUP_SET_STATE_CONFIGURATION = exports.CMS_COMPONENT_POPUP_SET_STATE_CONFIGURATION = 'CMS_COMPONENT_POPUP_SET_STATE_CONFIGURATION';

var CMS_COMPONENT_SLIDEOUT01_SET_STATE_CONFIGURATION = exports.CMS_COMPONENT_SLIDEOUT01_SET_STATE_CONFIGURATION = 'CMS_COMPONENT_SLIDEOUT01_SET_STATE_CONFIGURATION';
var CMS_COMPONENT_SLIDEOUT01_TOGGLE = exports.CMS_COMPONENT_SLIDEOUT01_TOGGLE = 'CMS_COMPONENT_SLIDEOUT01_TOGGLE';

var CMS_COMPONENT_SUB_MENU_TOGGLE = exports.CMS_COMPONENT_SUB_MENU_TOGGLE = 'CMS_COMPONENT_SUB_MENU_TOGGLE';
var CMS_COMPONENT_SUB_MENU_DEFAULT_OPEN = exports.CMS_COMPONENT_SUB_MENU_DEFAULT_OPEN = 'CMS_COMPONENT_SUB_MENU_DEFAULT_OPEN';

var CMS_COMPONENT_SUB_MENU_DROPDOWN_TOGGLE = exports.CMS_COMPONENT_SUB_MENU_DROPDOWN_TOGGLE = 'CMS_COMPONENT_SUB_MENU_DROPDOWN_TOGGLE';
var CMS_COMPONENT_SUB_MENU_DROPDOWN_SAVE_DATA = exports.CMS_COMPONENT_SUB_MENU_DROPDOWN_SAVE_DATA = 'CMS_COMPONENT_SUB_MENU_DROPDOWN_SAVE_DATA';

var CMS_COMPONENT_DROPDOWN_CLOSE = exports.CMS_COMPONENT_DROPDOWN_CLOSE = 'CMS_COMPONENT_DROPDOWN_CLOSE';
var CMS_COMPONENT_DROPDOWN_TOGGLE = exports.CMS_COMPONENT_DROPDOWN_TOGGLE = 'CMS_COMPONENT_DROPDOWN_TOGGLE';

var CMS_COMPONENT_TOGGLER_TOGGLE = exports.CMS_COMPONENT_TOGGLER_TOGGLE = 'CMS_COMPONENT_TOGGLER_TOGGLE';
var CMS_COMPONENT_TOGGLER_CLOSE_ALL = exports.CMS_COMPONENT_TOGGLER_CLOSE_ALL = 'CMS_COMPONENT_TOGGLER_CLOSE_ALL';